import React from 'react';

export const Button: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = props => {
  return (
    <>
      <style>
        {`.ricos-dev-tools-button:hover {
        background-color: rgba(203, 166, 247, .4);
        color: #cdd6f4;
    }`}
      </style>
      <button
        type="button"
        {...props}
        style={{
          border: 'none',
          textTransform: 'uppercase',
          fontWeight: 400,
          letterSpacing: '1px',
          padding: '6px 10px',
          margin: '0 0 0 8px',
          fontSize: '11px',
          color: 'rgba(205, 214, 244, .8)',
          transition: 'background .3s, color .3s',
          borderRadius: '2px',
          background: 'transparent',
          cursor: 'pointer',
        }}
        className={'ricos-dev-tools-button'}
      />
    </>
  );
};
